import DisconnectedEmailAccountBanner from './DisconnectedEmailAccountBanner';
import { jsx as _jsx } from "react/jsx-runtime";
const DisconnectedEmailAccountBannerList = ({
  connectedEmailAccounts,
  currentInboxId,
  isConversationsAdmin
}) => {
  return /*#__PURE__*/_jsx("div", {
    children: connectedEmailAccounts.valueSeq().map(channel => {
      if (channel.inboxId === currentInboxId && !channel.connected) {
        return /*#__PURE__*/_jsx(DisconnectedEmailAccountBanner, {
          channel: channel,
          currentInboxId: currentInboxId,
          isConversationsAdmin: isConversationsAdmin
        }, `${channel}-banner`);
      }
      return null;
    })
  });
};
DisconnectedEmailAccountBannerList.displayName = 'DisconnectedEmailAccountBannerList';
export default DisconnectedEmailAccountBannerList;